/**
 * Hire Onboarding Checklist API — Sprint 5 / Step 2.
 */
import { apiFetch } from './core'

export const hireOnboarding = {
    get: (employeeId) => apiFetch(`/hire-onboarding/${employeeId}`).catch((e) => {
        if (e?.status === 404 || e?.message?.includes('404')) return null
        throw e
    }),
    regenerate: (employeeId) => apiFetch(`/hire-onboarding/${employeeId}/regenerate`, {
        method: 'POST',
    }),
    updateTask: (taskId, patch) => apiFetch(`/hire-onboarding/tasks/${taskId}`, {
        method: 'PATCH',
        body: JSON.stringify(patch),
    }),
}
